<template>
  <div class="quick-login-register">
    <div class="quick-login-register-con">
      <div class="quick-login-head-form">
        <div class="lang-con">
          <div class="lang-select" @click="langTypeShow = true">
            <span class="lang-val">{{ selectLangType.text }}</span>
            <!-- <img class="down" src="../../assets/imgs/login/down.png" /> -->
            <i class="fas fa-chevron-down"></i>
          </div>
          <div class="mall-register-title-con">
            <h1 class="mall-register-title"><span>{{$t("common.title")}}</span></h1>
            <!-- <p class="mall-register-tip">{{$t("registerlogin.create_account_tip")}}</p> -->
            <p class="mall-register-tip">
              <i class="fas fa-mobile-alt imei-icon"></i>
              <span class="imei-title">IMEI:</span> {{imeiObj.imei}}
            </p>
          </div>
        </div>
        <!-- IMEI -->
        <!-- <div class="imei-top-con">
          <i class="fas fa-mobile-alt primary-color imei-icon"></i>
          <div>
            <span class="imei-title">IMEI:</span>
            <div class="imei-content">{{imeiObj.imei}}</div>
          </div>
          
        </div> -->

        <van-tabs class="van-tabs-con" :active="active" swipeable animated color="#4361ee" title-active-color="#1d3557" title-inactive-color="#6a7282" line-width="50%" @change="handleTabsChange">
          <van-tab name="email" :disabled="isHaveAccount" :title="$t('registerlogin.email_name')"></van-tab>
          <van-tab name="phone" :disabled="isHaveAccount" :title="$t('registerlogin.phone_name')"></van-tab>
        </van-tabs>

        <div class="login-form">
          <van-form @submit="onSubmit" ref="Form">
            <!-- 国家 -->
            <div v-if="!isHaveAccount" class="login-country-item">
                <van-field 
                    readonly
                    v-model="form.country"
                    :name="$t('registerlogin.country')"
                    class="field-input"
                    :placeholder="$t('registerlogin.country')" 
                    @click="handleCountry"
                >
                    <template #left-icon>
                      <i class="fas fa-solid fa-globe icon-color f16"></i>
                    </template>
                    <template #right-icon>
                        <img src="../../assets/imgs/login/down.png" alt="" class="field-right-img">
                    </template>
                </van-field>
                <div class="login-country-tips">
                    <!-- <img src="../../assets/imgs/login/exclamat.png" alt=""> -->
                    <i class="fas fa-solid fa-circle-info icon-color"></i>
                    <span>{{$t('registerlogin.select_country_tip')}}</span> 
                    <!-- <span>{{$t('registerlogin.select_country_tips')}}</span>  -->
                </div>
            </div>
            <!-- 邮箱 -->
            <van-field 
                @touchstart="handleForceFocus('emailInput')"
                ref="emailInput"
                v-if="active === 'email'"
                v-model.trim="form.email" 
                :name="$t('registerlogin.email_address')"
                class="field-input"
                :class="isHaveAccount ? 'field-input-readonly' : ''"
                clearable
                clear-trigger="always"
                :readonly="isHaveAccount"
                :placeholder="$t('registerlogin.email_address')" 
            >
                <template #left-icon>
                  <i class="fas fa-envelope icon-color f16"></i>
                </template>
            </van-field>
            <!-- 手机号码 -->
            <div v-if="active === 'phone' && !isHaveAccount" class="field-input login-phone">
                <div class="phone-label" :class="form.telprex ? '' : 'label-font'" @click="selectPhoneRoaming" dir="ltr">
                    <i class="fas fa-mobile-alt icon-color f16"></i>
                    {{form.telprex ? "+" + form.telprex : $t('registerlogin.global_roaming')}}
                    <img src="../../assets/imgs/login/down.png" />
                </div>
                <van-field
                    @touchstart="handleForceFocus('phoneInput')"
                    ref="phoneInput"
                    v-model.trim="form.phone"
                    :name="$t('registerlogin.phone_number')"
                    clearable
                    class="phone-value"
                    clear-trigger="always"
                    :placeholder="$t('registerlogin.phone_number')" 
                >
                  <!-- <template #left-icon>
                    <i class="fas fa-mobile-alt icon-color f16"></i>
                  </template> -->
                </van-field>
            </div>
            <van-field 
                v-if="active === 'phone' && isHaveAccount"
                :value="'+' + form.phone" 
                :name="$t('registerlogin.phone_number')"
                class="field-input field-input-readonly"
                clearable
                dir="ltr"
                clear-trigger="always"
                :readonly="isHaveAccount"
                :placeholder="$t('registerlogin.phone_number')" 
            >
                <template #left-icon>
                  <i class="fas fa-mobile-alt icon-color f16"></i>
                </template>
            </van-field>
            <!-- 密码 -->
            <van-field 
                @touchstart="handleForceFocus('password')"
                ref="password"
                v-model.trim="form.password" 
                :type="isShowPwd ? 'text' : 'password'" 
                name="password"
                class="field-input"
                :placeholder="$t('registerlogin.password')" 
                :rules="isHaveAccount ? [] : [{ pattern: pwdPattern, message: $t('registerlogin.please_enter') }]"
                @click-right-icon="handlerShowPwd"
            >
                <template #left-icon>
                  <i class="fas fa-lock icon-color f16"></i>
                </template>
                <template #right-icon>
                    <img v-if="form.password" :src="isShowPwd ? eye_fill : eye_close" alt="" class="field-right-img">
                </template>
            </van-field>
            <div class="forgot-password">
              <!-- 复选框 -->
              <van-checkbox class="remember-checkbox" v-model="form.rememberPwd" shape="square" checked-color="#4361ee" icon-size="0.444444rem" label-disabled>
                  <!-- <template #icon="props">
                      <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                  </template> -->
                  {{$t('registerlogin.rememberPwd')}}
              </van-checkbox>
              <span  @click="forgotPwd">{{$t('registerlogin.forgot_pwd')}}</span>
            </div>
            <!-- 复选框 -->
            <van-checkbox class="argeeflag-checkbox" v-model="form.argeeFlag" shape="square" checked-color="#4361ee" icon-size="0.444444rem" label-disabled>
                <!-- <template #icon="props">
                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template> -->
                {{$t('registerlogin.agree')}} 
                <a :href="User_Agreement" target="_blank" class="policy">{{$t('registerlogin.user_agreement')}}</a> 
                {{$t('registerlogin.and')}} 
                <a :href="Privacy_Policy" target="_blank" class="policy">{{$t('registerlogin.privacy_policy')}}</a> 
            </van-checkbox>
            <van-button class="login-btn" :disabled="btnIsDisabled" round block type="info" native-type="submit">{{ $t('registerlogin.register_login') }}</van-button>
          </van-form>
        </div>
        <van-divider v-if="isShowOtherLogin" :style="{ borderColor: '#dcdee0', margin: '0' }">{{$t('registerlogin.third_login')}}</van-divider>
        <div class="third-party-login" v-if="isShowThirdBtn || isAppleBtn">
          <div id="my-google-id" class="mr5 ml5"></div>
          <div id="appleid-signin" class="appleBtn" v-if="isAppleBtn" data-color="black" data-width="100%" data-height="100%" data-border="true" data-type="sign in" data-mode="logo-only"></div>
          <div class="mask" v-if="!form.argeeFlag" @click="handlerMask"></div>
        </div>
      </div>
      <div class="quick-login-footer">
      <!-- <div class="app-tips van-multi-ellipsis--l3" :class="isHaveAccount ? 'mt-80' : ''">• {{$t('registerlogin.app_tips')}}<a href="https://www.baidu.com" target="_blank">{{$t('registerlogin.download_app')}}</a></div> -->
      <div class="app-tips" v-if="!enterpriseObj.No_Module_Download_APP" v-html="this.AppDownLoadTips"></div>

      <div class="imei-con">{{ $t('common.footer_text') }}</div>
      </div>
    </div>

    <!-- 第三方登录选择国家 -->
    <SelectCountry v-if="isShowSelectCounty" :countryData="countryData" :iso2List="iso2List" :iso2="form.iso" @selectCountry="selectCountry"></SelectCountry>

    <!-- 提示 -->
    <WarnTips v-if="isShowWarnTips" @cancel="cancelWarnTips"></WarnTips>

    <!-- 语言选择弹窗 -->
    <van-popup v-model="langTypeShow" round position="bottom" custom-style="height: 30%">
      <van-picker 
        show-toolbar 
        :columns="columns" 
        @cancel="langTypeShow = false" 
        @confirm="onConfirm" 
        value-key="text" 
        :confirm-button-text="$t('registerlogin.confirm')"
        :cancel-button-text="$t('registerlogin.cancel')"
        item-height="6.5vh" />
    </van-popup>
    <!-- 国际区号选择弹窗 -->
    <van-popup v-model="roamingCodeShow" round position="bottom" custom-style="height: 30%">
      <van-picker 
        show-toolbar 
        :columns="getApiCountryData" 
        @cancel="roamingCodeShow = false" 
        @confirm="onConfirmRoaming" 
        value-key="text" 
        :confirm-button-text="$t('registerlogin.confirm')"
        :cancel-button-text="$t('registerlogin.cancel')"
        item-height="6.5vh" />
    </van-popup>

    <VerificationCode v-if="isShowCode" @cancel="cancelCode" :telprex="form.telprex" :enterpriseCode="imeiObj.enterprisecode" :phone="form.phone" @onConfirm="onConfirmCode"></VerificationCode>
  </div>
</template>

<script>
import { Tab, Tabs, Popup, Picker, Form, Field, Button, Checkbox, Toast, Divider} from "vant";
import { langTypes } from "./data";
import activeIcon from '../../assets/imgs/login/checked.png';
import inactiveIcon from '../../assets/imgs/login/uncheck.png';
import eye_close from '../../assets/imgs/login/eye_close.png';
import eye_fill from '../../assets/imgs/login/eye_fill.png';
import VerificationCode from './components/VerificationCode.vue';
import cookie from '../../utils/cookie';
import md5 from 'js-md5';
import UserLogin from '@/lib/UserLogin';
import AppAndtips from '@/data/appAndtips.js';
import Enterprise from '@/data/enterprise.js'
import { isIOS, debounce } from '@/utils/util.js';
import SelectCountry from './components/SelectCountry.vue';
import WarnTips from './components/WarnTips.vue'
export default {
  name: "QuickLogin",
  components: {
    vanTabs: Tabs,
    vanTab: Tab,
    vanPopup: Popup,
    vanPicker: Picker,
    vanForm: Form,
    vanField: Field,
    vanButton: Button,
    vanCheckbox: Checkbox,
    VerificationCode,
    vanDivider:Divider,
    SelectCountry,
    WarnTips,
  },
  data() {
    return {
      active: "email",
      langTypeShow: false,
      columns: langTypes,
      selectLangType: {
        text: "English",
        value: "en-US",
      },
      activeIcon,
      inactiveIcon,
      isShowPwd:false,
      eye_close,
      eye_fill,
      form:{
          email:'',
          password:'',
          phone:'',
          argeeFlag: false,
          iso:'',
          country:'',
          telprex:'',
          rememberPwd:true, // 记住密码
      },
      roamingCodeShow: false,
      getApiCountryData:[],
      isShowCode: false,
      isHaveAccount: false, // 是否有账号
      pwdPattern: /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?？。，；‘’“”：<>《》{}~`]{6,20}$/,
      appDownLoadTipsObj:{},
      mvnoMapProject:{},
      enterpriseObj:{},
      iso2List:[],
      IOSLoginData: {},
      isShowOtherLogin: false,
      isShowSelectCounty: false,
      countryData: [],
      thirdData:{},
      isShowThirdBtn: true,
      isAppleBtn: true,
      isShowWarnTips: false, // 是否显示提示组件，针对扫码进入但IMEI未导入的用户
    };
  },
  computed:{
      btnIsDisabled() {
          let flag = true
          let {email,phone,password,argeeFlag,iso} = this.form
          switch (this.active) {
              case 'email':
                  if(email && password && argeeFlag && (iso || this.isHaveAccount)){
                      flag = false
                  }
                  break;
              case 'phone':
                  if(password && phone && argeeFlag && (iso || this.isHaveAccount)){
                      flag = false
                  }
                  break;
          }
          return flag
      },
      // 获取路由参数
      imeiObj() {
        return this.$route.query
      },
      Country_iso:function(){
          return cookie.getCookie('GM_COUNTRY') || 'US';
      },
      User_Agreement(){
        return this.$APP_CONFIG["user_agreement_url_" + this.selectLangType?.value?.replace('-','_')];
      },
      Privacy_Policy() {
        return this.$APP_CONFIG["privacy_policy_url_" + this.selectLangType?.value?.replace('-','_')];
      },
      AppDownLoadTips() {
        let lang = this.selectLangType.value || cookie.getCookie('langType') || 'en-US';
        let str = this.appDownLoadTipsObj[lang]?.replace('%@imei',this.imeiObj.imei)
        str = str?.replace('%@pwd',this.imeiObj.pwd)
        return str;
      },
  },
  created(){
    // 清除部分缓存
    let isRegister = localStorage.getItem('isRegister');
    let rememberPwd = localStorage.getItem('rememberPwd');
    localStorage.clear();
    localStorage.setItem('isRegister',isRegister);
    localStorage.setItem('rememberPwd',rememberPwd);
    sessionStorage.clear();
    cookie.clearCookie('access_token');
    cookie.clearCookie('orgId');
    cookie.clearCookie('orgCode');
    cookie.clearCookie('mvnoCode');
    cookie.clearCookie('loginCustomerId');
  },
  mounted() {
      this.handlerThirdLogin();
      // this.httpcountryGroup();
      this.httpGetEnterpriseConfigList();
      this.httpGetImeiInfo();
      this.setDefaultLang();
      this.getAppDownLoadTips();
      // this.getMvnoMapProject();
      this.getEnterprise();
  },
  activated() {
    let regCountryData = JSON.parse(localStorage.getItem('regCountryData'));
    this.form.country = regCountryData?.value
    this.form.iso = regCountryData?.key
  },
  methods: {
    // 集成第三方登录
    handlerThirdLogin(){
      // 创建 script 标签 ---- 谷歌
      const script = document.createElement('script');
      script.id = 'custom-script';
      
      // 设置本地文件路径（文件需放在 public 目录）
      script.src = 'https://accounts.google.com/gsi/client';
      // script.src = '/client.js'; // 路径相对于 public 目录
      
      // 可选：定义加载成功/失败的逻辑
      script.onload = () => {
        this.$nextTick(() => {
          this.renderButton();
        })
      };
      script.onerror = () => {
        console.error('脚本加载失败')
        this.isShowThirdBtn = false;
      };
      
      // 将标签添加到 DOM
      document.body.appendChild(script);
      if(this.isSafari() && isIOS()){ // IOS登录
        const iosScript = document.createElement('script');
        iosScript.id = 'customIosScript';
        
        iosScript.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'; // 
        
        // 可选：定义加载成功/失败的逻辑
        iosScript.onload = () => {
          this.$nextTick(() => {
              let that = this;
              document.addEventListener('AppleIDSignInOnSuccess', debounce((event) => {
                    // alert("ios登录成功");
                    that.IOSLoginData = event.detail;
                    console.log("ios登录",event);
                    that.overseaIosLoginFun(event.detail);
                },400,{immediate: true}));
              document.addEventListener('AppleIDSignInOnFailure', (event) => {
                  // Toast.fail("Apple Sign In Error");
                  switch (event.detail.error) {
                    case 'popup_blocked_by_browser':
                      // 提示用户允许浏览器弹窗
                      this.$toast(this.$t('registerlogin.login_error_auth'));
                      break;
                    case 'popup_closed_by_user':
                      // 提示用户已取消登录
                      this.$toast(this.$t('registerlogin.login_error_cancel'));
                      break;
                  }
                  console.log("ios登录失败",event);
              });

              this.initAppleLogin();
          })
        };
        iosScript.onerror = () => {
          this.isAppleBtn = false;
          console.error('苹果脚本加载失败')
        };
        
        // 将标签添加到 DOM
        document.body.appendChild(iosScript);
      } else {
        this.isAppleBtn = false;
      }
    },
    // 初始化谷歌按钮,建议每次打开页面都再次初始化
    renderButton() {
      const that = this;
      const nonce = Math.random().toString(36).substr(2, 10);
      google.accounts.id.initialize({
        client_id: '371799375648-b267rhloo1ecfsumi0gen0i9inf952dg.apps.googleusercontent.com',// 生產环境
        // client_id: '365001481898-979mrtk22lqfftg5q3k5jl8fgnn1qhv2.apps.googleusercontent.com',// 测试环境
        ux_mode: 'popup', // redirect,popup
        callback: (response) => {
          that.overseaGoogleLoginFun(response);
        },
        onError: (error) => {
          // 处理不同错误码
          switch (error.code) {
            case 'popup_closed_by_user': // 用户关闭弹窗
              this.$toast(this.$t('registerlogin.login_error_cancel'));
              break;
            case 'popup_blocked_by_browser': // 浏览器阻止弹窗
              this.$toast(this.$t('registerlogin.login_error_auth'));
              break;
          }
        },
        auto_prompt: false, // 自动登录
        nonce: nonce,
      })
      const parent = document.getElementById('my-google-id');
        google.accounts.id.renderButton(parent, {
          size: "large",
          type: "icon",
          width: 300,
        });

        // 监听谷歌登录按钮渲染完成
        const container = document.getElementById('my-google-id');
        const observer = new MutationObserver(mutations => {
          // 检查谷歌登录按钮特有的iframe元素
          const googleIframe = container.querySelector('iframe[src*="accounts.google.com"]');
          if (googleIframe) {
            observer.disconnect(); // 停止监听
            // 执行后续操作（如动画效果）
            setTimeout(() => {
              that.setGoogleButtonStyle();
            }, 50);
          }
        });

        observer.observe(container, {
          childList: true,    // 监听子元素变化
          subtree: true       // 监听所有后代元素
        });

        // setTimeout(() => {
        //   this.setGoogleButtonStyle();
        // }, 800);
      this.isShowOtherLogin = true;
    },
    // 设置谷歌按钮样式
    setGoogleButtonStyle(){
      const googleBtn = document.querySelector('#my-google-id iframe');
      const googleCon = document.getElementById('my-google-id');
      if(googleBtn && googleCon){
        // 获取googleBtn的height和googleCon 的 height ，然后算出缩放比例， 对googleBtn进行缩放
        const btnHeight = googleBtn.offsetHeight - 4;
        const btnWidth = googleBtn.offsetWidth;
        const conHeight = googleCon.offsetHeight;
        const scale = conHeight / btnHeight;
        googleBtn.style.transform = `scale(${scale})`;
        googleBtn.style.transformOrigin = '0 0';
        googleBtn.style.left = '-' + ((btnWidth - btnHeight) / 2) * scale + 'px';
        googleBtn.style.top = '-2px';
      }
    },
    // 调用登录接口-谷歌
    overseaGoogleLoginFun(res){
       const responsePayload = this.decodeJwtResponse(res.credential);
       this.checkThirdUserExist({
          socialType: 'GOOGLE',
          openId: responsePayload.sub,
          email: responsePayload.email,
          nickName: responsePayload.name,
          token: res.credential,
       });
    },
    decodeJwtResponse(token) {
      let base64Url = token.split('.')[1];
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    },
    // 初始化IOS登录
    initAppleLogin(){
	      if (window.AppleID?.auth) {
	        const nonce = Math.random().toString(36).substr(2, 10);
	        window.AppleID.auth.init({
	          clientId: 'com.ucloudlink.iot.datamall', // 生产环境
            // redirectURI: "https://datamall.ucloudlink.com/qs",
            redirectURI: window.location.origin + window.location.pathname,
	          scope: 'name email',
	          state: `${Math.round(Math.random() * 100000000)}`,
	          nonce: nonce,
	          usePopup: true, // 使用当前页面弹出小窗的模式
	        });
          this.isShowOtherLogin = true;
	      }
    },		
    iosLogin: debounce(() => {
			try {
		       window.AppleID.auth.signIn()
           .then(res => {
              this.overseaIosLoginFun(res);
              // this.$toast(res)
           })
           .catch(err => {
              // this.$toast(err)
              console.error('Apple Sign In Catch Error: ', err);
           });
		    } catch ( error ) {
		       console.error('Apple Sign In Error: ', error);
		    }
		},400,{immediate: true}),
    // 调用登录接口-IOS
    overseaIosLoginFun(val) {
      const payload = JSON.parse(atob(val.authorization.id_token.split('.')[1]));
      // if(payload.email.indexOf('@') !== -1){
      //   email = payload.email;
      // }
      this.checkThirdUserExist({
          socialType: 'APPLE',
          openId: payload.sub, // user只在第一次登录返回
          email: val.user ? val.user.email : payload.email,
          nickName: val.user ? `${val.user.name.firstName} ${val.user.name.lastName}` : '',
          token: val.authorization.id_token,
       });
    },
    // 判断是否为 Safari
    isSafari(){
        let ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') !== -1;
        // return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
    },
    // 校验第三方用户是否存在
    checkThirdUserExist(data){
        this.$http
          .post({
            url: "/bss/app/noauth/CheckSocialUser",
            data: {
              socialType: data.socialType,
              openId: data.openId,
              email: data.email,
              enterpriseCode: this.imeiObj.enterprisecode,
            },
            auth:false
          })
          .then((res) => {
              switch (res.resultCode) {
                case '00000000':
                  this.isShowSelectCounty = true;
                  this.thirdData = {
                      socialType: data.socialType,
                      openId: data.openId,
                      email: data.email,
                      token: data.token,
                      nickName: data.nickName,
                  };
                  break;
                case '01020100': // 注册国家不存在
                  this.isShowSelectCounty = true;
                  this.thirdData = {
                      socialType: data.socialType,
                      openId: data.openId,
                      email: data.email,
                      token: data.token,
                      nickName: data.nickName,
                  };
                  break;
                case '01020040': // 用户已经存在
                  this.thirdPartyLogin({
                      socialType: data.socialType,
                      openId: data.openId,
                      // email: data.email,
                      token: data.token,
                      nickName: data.nickName,
                  });
                  break;
              }
          })
          .catch((err) => {
            this.$toast(err);
          });
    },
    // 第三方用户登录
    thirdPartyLogin(data){
      let params = {
          socialType: data.socialType,
          token: data.token,
          openId: data.openId,
          email: data.email,
          enterpriseCode: this.imeiObj.enterprisecode,
          registerChannel: 'GlocalMeIOT WEB'
      }
      if(data.registerCountry){
        params = {
          ...params,
          registerCountry: data.registerCountry,
        }
      }
      if(data.nickName){
        params = {
          ...params,
          nickName: data.nickName,
        }
      }
        this.$http
          .post({
            url: "/bss/app/noauth/SocialLogin",
            data: params,
            auth:false
          })
          .then((res) => {
            this.handlerLoginData(res.data,data.socialType);
        })
        .catch((err) => {
          this.$toast(err);
        });
    },
    // 未同意协议提示
    handlerAgreement(){
      if(!this.form.argeeFlag){
        this.$toast(this.$t('registerlogin.agreement_tips'));
        return false;
      } else {
        return true;
      }
    },
    selectCountry(selectData){
      this.isShowSelectCounty = false;
      this.thirdPartyLogin({
        ...this.thirdData,
        registerCountry: selectData.iso2
      })
    },
    // 点击遮罩
    handlerMask(){
      if(this.handlerAgreement()){
      }
    },
        // 获取app提示语
    getAppDownLoadTips() {
        AppAndtips.getConfig('appTips-config.json').then(d => {
            this.appDownLoadTipsObj = d.appDownLoadTips || {};
        })
    },
    // 获取mvonCode 对应 projectConfig 映射
    getMvnoMapProject(){
        AppAndtips.getConfig('mvnoMapProject.json').then(d => {
            this.mvnoMapProject = d || {};
        })
    },
    // 获取enterprise
    getEnterprise(){
      Enterprise.getConfig(this.imeiObj.enterprisecode + '.json').then(d => {
        this.enterpriseObj = d || {};
      })
    },
    // 设置默认语言
    setDefaultLang() {
      let browserLang = navigator.language.slice(0,2).toLowerCase()
      let langItem = langTypes.find(item => {
        if(['zh-TW','zh-HK'].includes(navigator.language)){
           return item.value === 'zh-TW';
        } else {
          let type = item.value.slice(0,2).toLowerCase();
          return browserLang === type;
        }
      })

      let lang = 'en-US';
      if(browserLang === 'id') {
        lang = 'in-ID';
        this.selectLangType.text = 'Indonesia';
        this.selectLangType.value = 'in-ID';
      }
      if(langItem?.value) {
        lang = langItem?.value;
        this.selectLangType.text = langItem?.text;
        this.selectLangType.value = langItem?.value;
      }

      this.$nextTick(() => {
        this.$i18n.locale = lang;
        cookie.setCookie('langType', lang,{expires: 365})
          // 对于阿拉伯语进行镜像反转
        const htmlNode = document.documentElement;  
        if(lang === 'ar-AE') {
            htmlNode.setAttribute('dir', 'rtl')
        } else {
          htmlNode.setAttribute('dir', 'ltr')
        }
        document.title = this.$t('common.title');
        localStorage.setItem('isSetLangType',true)
      })
    },

    // 查询IMEI账号信息
    httpGetImeiInfo() {
      const regex = /^\d+$/;
      this.$http
        .post({
          url: "/webmps/common/getCustomerByImei",
          data: {
            imei: this.imeiObj.imei,
          },
          auth:false
        })
        .then((res) => {
          let customerName = res?.data?.customerName
          if(customerName){
            this.isHaveAccount = true
            localStorage.setItem('isRegister',false);
            // 判断是不是邮箱
            if(customerName.indexOf('@') !== -1){
              this.active = 'email'
              this.form.email = customerName
            } else {
              this.active = 'phone'
              this.form.phone = customerName
            }
            this.form.argeeFlag = true;

            // 带出账号，如果记录了密码自动填充密码
            let rememberPwd = JSON.parse(localStorage.getItem('rememberPwd') || '[]');
            if(rememberPwd && rememberPwd.length > 0) {
                let pwdObj = rememberPwd.find(item => item.account === customerName);
                if(pwdObj) {
                    this.form.password = atob(pwdObj.pwd);
                    // 记住密码时自动登录
                    this.$nextTick(() => {
                      this.httpOnLogin();
                    })
                }
            }
          } else {
            this.isHaveAccount = false
          }
          // 神策-扫码进入该页面触发
            this.$sensors.track('WebRegorLoginPageInfo', {
              imei: this.imeiObj.imei,
              enterprisecode: this.imeiObj.enterprisecode,
              account: customerName || '',
              imei_is_right:regex.test(this.imeiObj.imei) && this.imeiObj.imei.length === 15 ? true : false,
            });
        })
        .catch((err) => {
          console.log(err);
          this.$toast(err);
        });
    },

    // 语言选择确认
    onConfirm(value, index) {
      if (value?.value) {
        let langType = value.value
        this.selectLangType.text = value.text;
        this.selectLangType.value = langType;
        this.$i18n.locale = langType;
        cookie.setCookie('langType', langType,{expires: 365})
          // 对于阿拉伯语进行镜像反转
        const htmlNode = document.documentElement;  
        if(langType === 'ar-AE') {
            htmlNode.setAttribute('dir', 'rtl')
        } else {
          htmlNode.setAttribute('dir', 'ltr')
        }
        document.title = this.$t('common.title');
        this.$refs?.Form?.resetValidation('password');
        this.httpcountryGroup();

        // 神策-点击语言选择
        this.$sensors.track('WebChooseLang', {
          lang_code: langType,
          imei: this.imeiObj.imei,
          enterprisecode: this.imeiObj.enterprisecode,
          lang_name: value.cnName,
        });

      }
      this.langTypeShow = false;
    },
    // 注册登录
    onSubmit(){
      if(!this.isHaveAccount){
        this.$refs.Form.validate('password')
        .then(() => {
          switch (this.active) {
            case 'email':
              this.httpRegister()
              break;
            case 'phone':
               this.$http
                .post({
                  url: "/bss/app/noauth/GetVerificationCodeBySMS",
                  data: {
                    phone: this.form.phone,
                    nationNum: this.form.telprex,
                    businessType: '1',
                    enterpriseCode: this.imeiObj.enterprisecode,
                  },
                  auth:false
                })
                .then((res) => {
                  switch (res.resultCode) {
                    case '00000000':
                      this.isShowCode = true;
                      break;
                    case '01020075':
                      this.$toast(res.resultDesc);
                      setTimeout(() => {
                        this.httpOnLogin()
                      }, 1500);
                      break;
                  }
                })
                .catch((err) => {
                  this.$toast(err);
                });

              // 神策-点击发送验证码
              this.$sensors.track('WebGetCodeClick', {
                service_type: '注册',
                get_type: '手机号',
                account: this.form.telprex + this.form.phone,
              });
              break;
          }
        })
        .catch(() => {})

      } else {
          this.httpOnLogin()
      }

      // 神策-点击注册登录按钮
      this.$sensors.track('WebRegisterLoginButtonClick', {
        page_title:'H5',
        imei: this.imeiObj.imei,
        account:this.form.email || (this.isHaveAccount ? this.form.phone : this.form.telprex + this.form.phone),
        oper_type:this.isHaveAccount ? '登录' : '注册',
        register_login_method: this.active === 'email' ? '邮箱' : '手机号',
      });

    },
    // 输入验证码校验通过后 ，进行注册
    onConfirmCode(code) {
        this.httpRegister(code)
    },
    // 调用注册
    httpRegister(code) {
        let { email, phone, iso, password, telprex} = this.form;
        let params = {
              password: md5(password),
              channelType: "WEB",
              enterpriseCode: this.imeiObj.enterprisecode,
              langType:this.selectLangType.value,
              registerCountry: iso,
        }
        switch (this.active) {
          case 'email':
            params = {
                userCode: email,
                registerType:'EMAIL',
                ...params,
            }
            break;
          case 'phone':
            params = {
                userCode: phone,
                registerType:'PHONE',
                countryCode: telprex,
                msgCode: code,
                ...params,
            }
            break;
        }
        this.$http
        .post({
          url: "/bss/app/noauth/RegisterUser",
          data: params,
          auth:false, // 不需要登录
        })
        .then((res) => {
          switch (res.resultCode) {
            case '00000000':
              localStorage.setItem('isRegister',true)
              this.httpOnLogin()
              break;
            case '01020040':
              this.$toast(res.resultDesc);
              setTimeout(() => {
                this.httpOnLogin()
              }, 1000);
              break;
            case '00000046':
              this.$toast(this.$t('registerlogin.register_error'));
              break;
            case '00000047':
              this.$toast(this.$t('registerlogin.register_error'));
              break;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast(err);
        });
    },
    // 调用登录
    httpOnLogin() {
        let { email, phone, password, telprex} = this.form;
        let params = {
              password: md5(password),
              channelType: "WEB",
              enterpriseCode: this.imeiObj.enterprisecode,
        }
        switch (this.active) {
          case 'email':
            params = {
                userCode: email,
                ...params,
            }
            break;
          case 'phone':
            params = {
                userCode: this.isHaveAccount ? phone : telprex + phone,
                ...params,
            }
            break;
        }
        this.$http
          .post({
            url: "/webmps/common/userLogin",
            data: {
                // "userCode": "1935424633@qq.com",
                // "password": "e10adc3949ba59abbe56e057f20f883e",
                // "channelType": "WEB",
                // "enterpriseCode": "EA00010032",
                ...params
            },
            auth:false,
          })
          .then((res) => {
            switch (res.resultCode) {
                  case '00000000':
                    this.handlerLoginData(res.data,this.active === 'email' ? 'EMAIL' : 'PHONE');
                    break;
                  case '00000046':
                    this.$toast(this.$t('registerlogin.login_error'));
                    break;
                  case '00000047':
                    this.$toast(this.$t('registerlogin.login_error'));
                    break;
                }
          })
          .catch((err) => {
            console.log(err);
            this.$toast(err);
          });
    },
    // 登录数据处理，持久化，及跳转页面
    handlerLoginData(res,socialType) {
      UserLogin.setAppThat(this).loginSuccess({
        data: {
          ...res,
          access_token: res.accessToken,
          imei: this.imeiObj.imei,
          loginCustomerId: res.userId,
          placeCode: res.registerCountry,
          isLoginByLoginPage:true,
          // mvnoCode: 
          // mvnoId: 
          // mvnoName: 
          // orgId: 
          // orgName: 
          // userCode: 
          // username: 
        }
      });

      // 神策-登录用户
      this.$sensors.login(res.userId);
      // 神策-设置公共属性
      this.$sensors.registerPage({
        imei: this.imeiObj.imei,
        projectConfig: res.mvnoCode,
        mvno_code: res.mvnoCode,
        is_login:true,
        operate_country: res.registerCountry,
        user_account: this.form.email || (this.isHaveAccount ? this.form.phone : this.form.telprex + this.form.phone),
        socialType
      });

      // 记住密码
      if(['EMAIL','PHONE'].includes(socialType)){
        let rememberPwd = JSON.parse(localStorage.getItem('rememberPwd') || '[]') || [];
        let phone = this.isHaveAccount ? this.form.phone : this.form.telprex + this.form.phone;
        let pwdObj = rememberPwd.find(item => item.account === (this.form.email || phone));
        if(this.form.rememberPwd){
          if(pwdObj) {
              pwdObj.pwd = btoa(this.form.password);
          } else {
              rememberPwd.push({
                  account: this.form.email || phone,
                  pwd: btoa(this.form.password),
              })
          }
          localStorage.setItem('rememberPwd',JSON.stringify(rememberPwd));
  
        } else {
          rememberPwd = rememberPwd.filter(item => item.account !== (this.form.email || phone));
          localStorage.setItem('rememberPwd',JSON.stringify(rememberPwd));
        }
      }

      // &placeCode=
      if(this.isHaveAccount && ['EMAIL','PHONE'].includes(socialType)) {
        let projectConfig = this.enterpriseObj[res.mvnoCode + '_MapProjectConfig'] || this.enterpriseObj['Default_MapProjectConfig'] || res.mvnoCode;
        sessionStorage.setItem('Module_Bind_Group',this.enterpriseObj.Module_Bind_Group);
        localStorage.setItem('Module_Bind_Group',this.enterpriseObj.Module_Bind_Group);
        sessionStorage.setItem('isLoginByLoginPage', true);
        sessionStorage.setItem('loginPageUrl', window.location.href);
        localStorage.setItem('isRegAndLogin',true);
        let redirect_url = encodeURIComponent(window.location.href);
        let href = `/Home?projectConfig=${projectConfig}&imei=${this.imeiObj.imei}&isLoginByLoginPage=true&endString=true&redirect_url=${redirect_url}`;
        window.location.replace(window.location.origin + href);
      } else {
        this.httpBindIMEi(res)
      }
    },
    // 绑定设备调用接口
    httpBindIMEi(data) {
      let that = this;
      let requestUrl = '/bss/app/group/AddGroup';
      if(!this.enterpriseObj.Module_Bind_Group){
        requestUrl = "/bss/app/terminal/HandleDeviceBinding";
      }
        this.$http
          .post({
            url: requestUrl,
            data: {
              access_token: data.accessToken,
              loginCustomerId: data.userId,
              operateType: '0',
              customerId: data.userId,
              imei: that.imeiObj.imei,
              // forceFlag: true,
              password: that.imeiObj.pwd,
              enterpriseCode: that.imeiObj.enterprisecode,
              mvnoCode:data.mvnoCode,
              partnerCode:this.enterpriseObj.partnerCode || 'MAYA'
            },
            auth:false, // 不需要登录
          })
          .then((res) => {

              if(res.resultCode === '01080001'){
                this.isShowWarnTips = true;
                    // 神策-暂时收集未导入系统IMEI
                    this.$sensors.track('WebCollectNotImportIMEI', {
                      imei: this.imeiObj.imei,
                      terminalType: this.imeiObj.terminalType,
                      enterprisecode: this.imeiObj.enterprisecode,
                    });
              } else {
                Toast.loading({
                  duration: 0, // 持续展示 toast
                  forbidClick: true,
                  //message: "加载中..."
                });
                // 神策-绑定imei
                this.$sensors.track('WebBindDevice', {
                  device_id: that.imeiObj.imei,
                  is_success: true,
                });
  
                let projectConfig = this.enterpriseObj[data.mvnoCode + '_MapProjectConfig'] || this.enterpriseObj['Default_MapProjectConfig'] || data.mvnoCode;
                sessionStorage.setItem('Module_Bind_Group',this.enterpriseObj.Module_Bind_Group);
                localStorage.setItem('Module_Bind_Group',this.enterpriseObj.Module_Bind_Group);
                sessionStorage.setItem('isLoginByLoginPage', true);
                sessionStorage.setItem('loginPageUrl', window.location.href);
  
                setTimeout(() => {
                    Toast.clear();
                    localStorage.setItem('isRegAndLogin',true);
                    let redirect_url = encodeURIComponent(window.location.href);
                    let href = `/Home?projectConfig=${projectConfig}&imei=${that.imeiObj.imei}&isLoginByLoginPage=true&endString=true&redirect_url=${redirect_url}`;
                    window.location.replace(window.location.origin + href);
                }, 1000);
              }

          })
          .catch((err) => {
            console.log(err);
            this.isShowCode = false;
            this.$toast(err);
            
            // 神策-绑定imei
            this.$sensors.track('WebBindDevice', {
              device_id: that.imeiObj.imei,
              is_success: false,
              fail_reason: err,
            });

          });
    },
    // 切换密码框
    handlerShowPwd(){
        this.isShowPwd = !this.isShowPwd
    },
    // 切换tab
    handleTabsChange(name,title) {
        this.active = name;
        this.form.email = '';
        this.form.phone = '';
        this.form.password = '';
        this.$refs?.Form?.resetValidation('password');
    },
    // 跳转选择国家列表
    handleCountry() {
        this.$router.push({
            path:'/qs/registerCountry',
            query:{
              imei:this.imeiObj.imei,
              enterprisecode: this.imeiObj.enterprisecode,
            }
        })
    },
    // 接口获取分站信息
    httpGetEnterpriseConfigList(){
        this.$http
        .post({
          url: "/bss/app/noauth/queryEnterpriseConfigList",
          data: {
            partnerCode: "MAYA",
            enterpriseCode: this.imeiObj.enterprisecode,
          },
          auth:false, // 不需要登录
        })
        .then((res) => {
          if(res.data && res.data.length){
            res.data.forEach((item) => {
              if(item.iso2List && item.iso2List.length){
                this.iso2List = this.iso2List.concat(item.iso2List);
              }
            })
          }
          this.httpcountryGroup();
        })
        .catch((err) => {
          console.log(err);
          this.$toast(err);
        });
    },
    // 接口获取国家
    httpcountryGroup() {
      this.$http
        .post({
          url: "/bss/app/noauth/QueryCoverCountyInfo",
          data: {
            partnerCode: "MAYA",
            // coverFlag: "SHOW",
          },
          auth:false
        })
        .then((res) => {
          if (res.data) {
            this.countryData = res.data;
            // 根据分站配置展示国家
            if(this.iso2List.includes('ALL')){
                this.getApiCountryData = res.data.filter((item) => {
                    return item.iso2 !== 'ALL' && item.telprex
                }).map((item) =>　{
                    return {
                        ...item,
                        text:item.countryName + " +" + item.telprex,
                        value:item.iso2
                    }
                });
            } else {
              this.getApiCountryData = res.data.filter((item) => {
                  return item.iso2 !== 'ALL' && item.telprex && this.iso2List.includes(item.iso2)
              }).map((item) =>　{
                  return {
                      ...item,
                      text:item.countryName + " +" + item.telprex,
                      value:item.iso2
                  }
              });
            }

            this.getApiCountryData.find(item => {
              let a = {
                  key: item.iso2,
                  value: item.countryName,
              }
              if(item.iso2 === this.Country_iso && !this.form.iso && (this.iso2List.includes('ALL') || this.iso2List.includes(item.iso2))){

                localStorage.setItem('regCountryData', JSON.stringify(a));

                this.form.telprex = item.telprex;
                this.form.country = item.countryName;
                this.form.iso = item.iso2;
                return true;

              } else if(item.iso2 === this.form.iso){

                localStorage.setItem('regCountryData', JSON.stringify(a));

                if(this.form.country){
                  this.form.country = item.countryName;
                  return true;
                }

              } else if(this.iso2List.includes(item.iso2) && !this.form.telprex){
                this.form.telprex = item.telprex;
              }
            })
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast(err);
        });
    },
    // 输入框获取焦点
    handleForceFocus(ref) {
      this.$refs[ref].focus();
    },
    // 打开国际区号选择
    selectPhoneRoaming() {
        this.roamingCodeShow = true;
    },
    // 确认区号选择
    onConfirmRoaming(value,index) {
        this.roamingCodeShow = false;
        this.form.telprex = value.telprex
    },
    // 忘记密码
    forgotPwd() {
        this.$router.push({
            path:'/qs/forgotPwd',
            query:{
                loginType:this.active,
                enterpriseCode: this.imeiObj.enterprisecode,
                telprex:this.form.telprex,
            }
        })
    },
    // 取消验证码
    cancelCode() {
        this.isShowCode = false
    },
    // 取消未导入IMEI提示
    cancelWarnTips(){
      this.isShowWarnTips = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "css/index.less";
</style>